import { object, bool, string, node, func } from 'prop-types';
import queryString from 'query-string';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { compose, withProps, defaultProps } from 'recompose';

/**
 * Normalize to prop from string to object .
 *
 * @param {string|object} to String to normalize or object to return
 * @returns {object}
 */
function normalizeToObject(to) {
  return typeof to === 'string' ? { pathname: to } : { ...to };
}

/**
 * This component uses Link from React Router and updates
 * only the pathname so search parameters are preserved.
 */
const CustomLink = ({
  className,
  to,
  children,
  /** These are props passed by Downshift in TopicNavigation */
  onMouseMove,
  onMouseDown,
  onClick,
  id,
  target,
  dataPw,
}) => {
  const additionalProps =
    target === '_blank'
      ? {
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      : {};
  return (
    <RouterLink
      className={className}
      to={to}
      onMouseMove={onMouseMove}
      onMouseDown={onMouseDown}
      onClick={onClick}
      id={id}
      data-pw={dataPw}
      {...additionalProps}
    >
      {children}
    </RouterLink>
  );
};

CustomLink.propTypes = {
  ...RouterLink.propTypes,
  className: string,
  children: node.isRequired,
  onMouseMove: func,
  onMouseDown: func,
  onClick: func,
};

export const LinkWithSearchParams = compose(
  withRouter,
  defaultProps({ preserveSearch: false }),
  withProps(({ to, location, preserveSearch }) => {
    // Check if search is included in the to URL
    const includesSearch = normalizeToObject(to).pathname.includes('search');
    // Retrieve current search parameters
    const oldSearchParams = queryString.parse(location.search);
    // Remove all 'query' search parameters for non search links
    let newSearchParams = {};
    // Check if we want to conserve those values
    if (preserveSearch) {
      newSearchParams = {
        ...oldSearchParams,
      };
    }

    // Remove query if it's in the URL
    if (includesSearch) {
      newSearchParams.query = undefined;
    }

    return {
      to: {
        ...normalizeToObject(to),
        search: queryString.stringify(newSearchParams),
      },
    };
  })
)(CustomLink);

LinkWithSearchParams.propTypes = {
  ...RouterLink.propTypes,
  /** React Routers withRouter props */
  match: object,
  location: object,
  history: object,
  preserveSearch: bool,
};
